

































import Vue from "vue";
import Component from "vue-class-component";
import { maps } from "@/store";
import { MutationTypes } from "@/store/mutations-types";

interface IFeature {
  name: string;
  key: string;
}

@Component
export default class FeaturesMenu extends Vue {
  //data
  features: IFeature[] = [
    {
      name: "Plataformas fijas",
      key: "fixedPlatforms",
    },
    {
      name: "Plataformas móviles",
      key: "mobilePlatforms",
    },
    {
      name: "Zonas de fondeo (Carta naútica)",
      key: "chartAchare",
    },
    {
      name: "Tuberías",
      key: "pipelines",
    },
    {
      name: "Canales de navegación",
      key: "navchannels",
    },
  ];

  //computed
  get featureSelector() {
    return maps.getters.selectedFeatures;
  }
  set featureSelector(value) {
    maps.commit(MutationTypes.SELECT_FEATURES, value);
  }
}
